document.addEventListener("DOMContentLoaded", function () {
	// 「カートに追加」ボタンを取得
	const addToCartButtons = document.querySelectorAll(".add-cart-btn-js");

	addToCartButtons.forEach((button) => {
		button.addEventListener("click", function () {
			const variantId = this.dataset.variantId;

			fetch("/cart/add.js", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Accept: "application/json",
				},
				body: JSON.stringify({
					id: variantId,
					quantity: 1,
				}),
			})
				.then((response) => response.json())
				.then((data) => {
					console.log("商品が追加されました:", data);
					updateCartSidebar();

					// SP幅でカートサイドバーを自動的に開く
					if (window.innerWidth <= 1200) {
						const cartSidebar = document.getElementById("cart-sidebar");
						if (cartSidebar) {
							cartSidebar.classList.add("active");
						}
					}
				})
				.catch((error) => {
					console.error("追加エラー:", error);
				});
		});
	});

	// SP幅カートのサイドバー開閉
	const cartSidebar = document.getElementById("cart-sidebar");
	const cartSidebarAccordion = document.querySelector(".cart-sidebar-header");
	if (cartSidebarAccordion) {
		cartSidebarAccordion.addEventListener("click", () => {
			cartSidebar.classList.toggle("active");
		});
	}

	// ページ読み込み時にも表示更新
	updateCartSidebar();
});

function updateCartSidebar() {
	fetch("/cart.js")
		.then((response) => response.json())
		.then((cart) => {
			const cartItemsContainer = document.getElementById("cart-sidebar-items");
			const totalAmountElement = document.getElementById(
				"cart-sidebar-total-price"
			);

			if (!cartItemsContainer || !totalAmountElement) {
				console.warn(
					"cart-items または cart-total-price が見つかりませんでした。"
				);
				return;
			}

			cartItemsContainer.innerHTML = "";

			if (cart.items.length === 0) {
				cartItemsContainer.innerHTML = "<p>カートは空です</p>";
				totalAmountElement.textContent = "0円";
				// ヘッダーのカート個数表示を更新（空の場合）
				updateHeaderCartCount(0);
				return;
			}

			// 商品一覧を挿入
			cart.items.forEach((item) => {
				const itemHtml = `
					<div class="cart-sidebar-item">
					  <div class="cart-sidebar-item-image">
						<img src="${item.image}" alt="${item.product_title}" />
					  </div>
					  <div class="cart-sidebar-item-details">
						<div class="cart-sidebar-item-name">${item.product_title}</div>
						<div class="cart-sidebar-item-price">
						  ${(item.final_line_price / item.quantity / 100).toLocaleString()}円 × ${
					item.quantity
				}個
						</div>
						<button class="cart-sidebar-remove-button" data-key="${item.key}">削除</button>
					  </div>
					</div>
				`;
				cartItemsContainer.insertAdjacentHTML("beforeend", itemHtml);
			});

			// 小計（total_price）を反映
			totalAmountElement.textContent = `${(
				cart.total_price / 100
			).toLocaleString()}円`;

			// ヘッダーのカート個数表示を更新
			updateHeaderCartCount(cart.item_count);

			// 削除ボタンにイベント付与
			document
				.querySelectorAll(".cart-sidebar-remove-button")
				.forEach((btn) => {
					btn.addEventListener("click", function () {
						const key = this.dataset.key;

						fetch("/cart/change.js", {
							method: "POST",
							headers: {
								"Content-Type": "application/json",
								Accept: "application/json",
							},
							body: JSON.stringify({
								id: key,
								quantity: 0,
							}),
						})
							.then((res) => res.json())
							.then((updatedCart) => {
								console.log("商品が削除されました:", updatedCart);
								updateCartSidebar(); // 再描画
							})
							.catch((error) => console.error("削除エラー:", error));
					});
				});
		})
		.catch((error) => {
			console.error("カート読み込みエラー:", error);
		});
}

// ヘッダーのカート個数表示を更新する関数
function updateHeaderCartCount(itemCount) {
	const cartCountBubble = document.querySelector(".cart-count-bubble");

	if (itemCount === 0) {
		// カートが空の場合は、カート個数表示を非表示にする
		if (cartCountBubble) {
			cartCountBubble.style.display = "none";
		}
	} else {
		// カートに商品がある場合
		if (cartCountBubble) {
			// 既存の要素を更新
			cartCountBubble.style.display = "flex";
			const ariaHiddenSpan = cartCountBubble.querySelector(
				'span[aria-hidden="true"]'
			);
			const visuallyHiddenSpan =
				cartCountBubble.querySelector(".visually-hidden");

			if (ariaHiddenSpan) {
				ariaHiddenSpan.textContent = itemCount < 100 ? itemCount : "";
			}
			if (visuallyHiddenSpan) {
				visuallyHiddenSpan.textContent = `${itemCount}個のアイテム`;
			}
		} else {
			// カート個数表示が存在しない場合は新しく作成
			const cartIcon = document.querySelector(".cart-icon");
			if (cartIcon) {
				const newCartCountBubble = document.createElement("div");
				newCartCountBubble.className = "cart-count-bubble";
				newCartCountBubble.innerHTML = `
					${itemCount < 100 ? `<span aria-hidden="true">${itemCount}</span>` : ""}
					<span class="visually-hidden">${itemCount}個のアイテム</span>
				`;
				cartIcon.appendChild(newCartCountBubble);
			}
		}
	}
}
